import { useEffect, useRef, useState } from 'react';

export default function useHasOverflow<T extends HTMLElement>(delay?: number) {
  const ref = useRef<T>(null);
  const [hasOverflow, setHasOverflow] = useState<boolean>();

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    let timeout;
    if (delay) {
      timeout = setTimeout(() => {
        setHasOverflow(element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth);
      }, delay);
    } else {
      setHasOverflow(element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [delay]);

  return { ref, hasOverflow };
}
